import { useBrandConfig } from '~/config/branding';
import { Benefits } from './Benefits';
import { FAQ } from './FAQs';

export const Organizations = () => {
  const { siteName } = useBrandConfig();
  return (
    <div className="text-left min-h-screen bg-white">
      {/* [MCV-1512] The route's product sections are `h2`, so without this the
          outline starts at `h2` and screen-reader heading navigation has no
          page title. The visual design has no page-level title and Elise signed
          off on it as-is, so this stays `sr-only` rather than introducing an
          unreviewed heading.
          [MCV-1490] Brand-specific now that each site shows only its own
          section. */}
      <h1 className="sr-only">{siteName} for healthcare organizations</h1>
      <Benefits />
      <FAQ />
    </div>
  );
};
